import * as tslib_1 from "tslib";
import encryptApi from "@cloudpivot/common/src/utils/aes/index";
import axios from "axios";
import Vue from "vue";
import env from "./env";
const CancelToken = axios.CancelToken;
Vue.prototype.$httpRequestList = [];
const prefixs = [
    "/api",
    "/externalLink",
    "/login/mobile/ajax",
    "/login/wx/ajax",
    "/public/system/config",
    "/logout"
];
let refreshingTokenLock = false;
// 请求拦截器
axios.interceptors.request.use((config) => tslib_1.__awaiter(this, void 0, void 0, function* () {
    //
    // prefix.forEach((pre: string) => {
    //   if (!env.enableProxy && (config.url as string).slice(0, pre.length) === pre) {
    //     config.url = `${env.apiHost}${config.url}`;
    //   }
    // });
    if (!env.enableProxy &&
        prefixs.some(pre => !!config.url && config.url.slice(0, pre.length) === pre)) {
        config.url = `${env.apiHost}${config.url}`;
    }
    const expiration = localStorage.getItem("expireTime") ? localStorage.getItem("expireTime") : "";
    const refresh_token = localStorage.getItem("refresh_token");
    const corpId = localStorage.getItem("corpId");
    const nowDate = new Date().getTime();
    const isOther = /login\/Authentication\/get_refresh_token/g.test(config.url);
    const language = localStorage.getItem('locale') || 'en';
    let canRefresh = false;
    if (window.config.refreshTokenEachHour) {
        const refreshTokenPeroid = window.config.refreshTokenPeroid;
        const activeHour = Number(localStorage.getItem("activeHour")) || 8;
        for (let i = (activeHour - 1); i >= 0; i--) {
            if (nowDate > parseInt(expiration) * 1000 - refreshTokenPeroid * 60000 - i * 3600000 &&
                !isOther &&
                nowDate <= parseInt(expiration) * 1000 - i * 3600000 &&
                refresh_token) {
                canRefresh = true;
                break;
            }
        }
    }
    else if (nowDate > parseInt(expiration) * 1000 - 1200000 &&
        !isOther &&
        nowDate <= parseInt(expiration) * 1000 &&
        refresh_token) {
        canRefresh = true;
    }
    if (canRefresh && !refreshingTokenLock) {
        refreshingTokenLock = true;
        setTimeout(() => {
            refreshingTokenLock = false;
        }, 3000);
        console.log('刷新token，当前是第' +
            Math.floor((nowDate - parseInt(expiration) * 1000) / 3600000 + 8) +
            '小时第' +
            Math.floor(((nowDate - parseInt(expiration) * 1000) % 3600000) /
                60000 +
                60) +
            '分钟');
        yield axios
            .get(`${env.oauthHost}/login/Authentication/get_refresh_token?refresh_token=${refresh_token}&corpId=${corpId}`)
            .then((res) => {
            // console.log(res);
            if (!res.errcode) {
                const token = res.access_token;
                const refreshTokens = res.refresh_token;
                const expireTime = res.exp;
                if (token && refreshTokens && expireTime) {
                    localStorage.setItem('refresh_token', refreshTokens);
                    localStorage.setItem('expireTime', expireTime);
                    localStorage.setItem('token', token);
                }
            }
        });
    }
    // 每次发送请求之前检测localStorage存有token,那么都要放在请求头发送给服务器
    const token = window.externalLinkToken || localStorage.getItem("token");
    if (token) {
        if (config.url.indexOf('/nsc/webeam/config') > -1
            || config.url.indexOf('/nsc/login/userinfo') > -1
            || config.url.indexOf('/OngoingNewHire/updateAgree') > -1
            || config.url.indexOf('/OngoingNewHire/getAgree') > -1
            || config.url.indexOf('/OngoingNewHire/updateOngoingStatus') > -1
            || config.url.indexOf('/OngoingNewHire/socialInsurance/sendMail') > -1
            || config.url.indexOf('/email/noAuth/sendForTemplate') > -1
            || config.url.indexOf('/OngoingNewHire/getHROBProposal') > -1
            || config.url.indexOf('/jobtran/noAuth/queryTable') > -1
            || config.url.indexOf('.core.chinacloudapi.cn') > -1) {
        }
        else {
            config.headers.Authorization = `Bearer ${token}`;
            if (process.env.NODE_ENV === 'debug') {
                config.headers.RequestType = 'AuthineTest';
            }
        }
    }
    // setTimeout(()=>{
    if (language && config && config.headers) {
        switch (language) {
            case 'zh':
                config.headers['Accept-Language'] = 'zh-CN';
                break;
            case 'en':
                config.headers['Accept-Language'] = 'en-US';
                break;
        }
    }
    else {
        config.headers['Accept-Language'] = 'zh-CN';
    }
    // },500)
    config.cancelToken = new CancelToken(c => {
        //强行中断请求要用到的
        Vue.prototype.$httpRequestList.push(c);
    });
    let isEncrypt = window.localStorage.getItem("isEncrypt") === '1';
    if (isEncrypt && config.data) {
        console.log(config.url + ":" + JSON.stringify(config.data));
        config.data = {
            param: encryptApi.encrypt(JSON.stringify(config.data))
        };
    }
    if (isEncrypt && config.params) {
        let formatParams = {};
        const params = config.params;
        for (let element in params) {
            if (params.hasOwnProperty(element) && params[element] !== undefined) {
                formatParams[element] = encryptApi.encrypt(params[element]);
            }
        }
        config.params = formatParams;
    }
    // 二开 接口加密
    if (config.url.indexOf("/api/organization/user/info") > -1 ||
        config.url.indexOf("/api/qrcode/generate_qrcode") > -1 ||
        config.url.indexOf("/api/TA/getApprover") > -1) {
        const KEY = env.encrypt_totalRewards.KEY;
        const IV = env.encrypt_totalRewards.IV;
        if (config.data) {
            config.data = {
                param: encodeURIComponent(encryptApi.encrypt_iv(JSON.stringify(config.data, KEY, IV)))
            };
        }
        if (config.params) {
            let formatParams = {};
            const params = config.params;
            for (let element in params) {
                if (params.hasOwnProperty(element) && params[element] !== undefined) {
                    formatParams[element] = encodeURIComponent(encryptApi.encrypt_iv(params[element], KEY, IV));
                }
            }
            config.params = formatParams;
        }
        if (config.url.indexOf("/api/organization/user/info") > -1) {
            if (config.url.indexOf("?") > -1) {
                const paramsUrl = "?" + config.url.split("?")[1];
                const id = window.getQueryString(paramsUrl, "id");
                const refIdEncrypt = encryptApi.encrypt_iv(id, KEY, IV);
                const newurl = config.url.split("?")[0] + "?id=" + encodeURIComponent(refIdEncrypt);
                config.url = newurl;
            }
        }
        else if (config.url.indexOf("/api/qrcode/generate_qrcode") > -1) {
            if (config.url.indexOf("?") > -1) {
                const paramsUrl = "?" + config.url.split("?")[1];
                const text = window.getQueryString(paramsUrl, "text");
                const refIdEncrypt = encryptApi.encrypt_iv(text, KEY, IV);
                const newurl = config.url.split("?")[0] + "?text=" + encodeURIComponent(refIdEncrypt);
                config.url = newurl;
            }
        }
    }
    //  IPS 模块advancedSearch 跳转的表单 load接口需要增加参数 AcknowledgementAdmin 用于后台修改数据权限
    if (config.url.indexOf("/api/runtime/form/load") > -1) {
        let newUrl = decodeURIComponent(window.location.href);
        if (newUrl.indexOf("return=/application/IPS/application-list/advancedSearch") > -1 ||
            newUrl.indexOf("tempAuthPropertyCode=tsrIdRelevance") > -1 ||
            newUrl.indexOf("tempAuthPropertyCode=blaID") > -1 ||
            newUrl.indexOf("tempAuthPropertyCode=tsrID") > -1 ||
            newUrl.indexOf("return=/application/organizational_development/application-list/PositionTitleChangeSSC") > -1 ||
            newUrl.indexOf("return=/application/organizational_development/application-list/FLRReport") > -1 ||
            (newUrl.indexOf("return=/application/on_boarding/") > -1 && newUrl.indexOf("return=/application/on_boarding/application-list/PositionID") === -1) ||
            newUrl.indexOf("return=/application/RecruitingTool/application-list/LocalRecuritingReport") > -1 ||
            newUrl.indexOf("return=/application/RecruitingTool/application-list/InternRecuritingReport") > -1 ||
            newUrl.indexOf("return=/application/jobTransfer/application-list/JT_Report_SSC") > -1 ||
            newUrl.indexOf("return=/application/jobTransfer/application-list/JT_Report") > -1 ||
            newUrl.indexOf("return=/application/newHireData/application-list/DataCollection") > -1 ||
            newUrl.indexOf("returnto=/application/ExitProcess/application-list/SSCEmployeeList") > -1) {
            config.params.AcknowledgementAdmin = true;
        }
    }
    //  OR  load接口需要增加参数 AcknowledgementAdmin 用于后台修改数据权限
    if (config.url.indexOf("/api/runtime/form/load") > -1 && config.params) {
        let newUrl = decodeURIComponent(window.location.href);
        if (newUrl.indexOf("return=/application/overseas_remittance/application-list1/Tax_Reporting") > -1) {
            config.params.AcknowledgementAdmin = true;
        }
    }
    //  New Chop 模块 All Attachments 跳转的表单 load接口需要增加参数 AcknowledgementAdmin 用于后台修改数据权限
    if (config.url.indexOf("/api/runtime/form/load") > -1) {
        let newUrl = decodeURIComponent(window.location.href);
        if (newUrl.indexOf("return=/application/IPS/application-list/new_Chop") > -1) {
            config.params.AcknowledgementAdmin = true;
        }
    }
    //  New Chop 模块   Advanced Report 跳转的表单 load接口需要增加参数 AcknowledgementAdmin 用于后台修改数据权限
    if (config.url.indexOf("/api/runtime/form/load") > -1) {
        let newUrl = decodeURIComponent(window.location.href);
        if (newUrl.indexOf("return=/application/new_Chop/application-list/new_chop_advanced_report") > -1) {
            config.params.AcknowledgementAdmin = true;
        }
    }
    return config;
}), error => Promise.reject(error));
// 响应拦截器
axios.interceptors.response.use(response => {
    if (response.config.url && response.config.url.indexOf('/public/system/config') > -1) {
        // 从这个接口中获取后端是否加密的参数, 如果加密的话
        for (let item in response.headers) {
            if (response.headers.hasOwnProperty(item) && item.toLowerCase() === 'isencrypt') {
                window.localStorage.setItem("isEncrypt", response.headers[item] === 'true' ? '1' : '0');
            }
        }
    }
    let isEncrypt = window.localStorage.getItem("isEncrypt") === '1';
    if (isEncrypt) {
        let resJSON = encryptApi.decrypt(response.data);
        console.log(response.config.url + ':' + resJSON);
        if (resJSON) {
            let resObj = JSON.parse(resJSON);
            return resObj;
        }
        else {
            return null;
        }
    }
    else {
        if ((response.config.url && response.config.url.indexOf('/api/azure/download') > -1) ||
            (response.config.url && response.config.url.indexOf('/api/certificate/downloadCertificatePDF') > -1) ||
            (response.config.url && response.config.url.indexOf('/api/certificate/exportExecl') > -1) ||
            (response.config.url && response.config.url.indexOf('/api/coi/downloadCoiReportExcel') > -1) ||
            (response.config.url && response.config.url.indexOf('/api/coi/downloadCoiArchivingExcel') > -1)) {
            return response;
        }
        else {
            return response.data;
        }
    }
}, error => {
    if (error.response) {
        switch (error.response.status) {
            case 401:
                if (env.hasSSO) {
                    //38 及 88 环境 需要下面代码，
                    if (error.response.config &&
                        error.response.config.url.indexOf("public/system/config") === -1) {
                        const corpId = localStorage.getItem("corpId") || "";
                        let returnUrl = '';
                        if (window.top !== window.self) {
                            console.log(window.parent.location.href);
                            returnUrl = window.parent.location.href;
                        }
                        let url = `${env.portalHost}/login`;
                        if (corpId) {
                            url = `${url}?corpId=${corpId}`;
                        }
                        // eslint-disable-next-line no-alert
                        // alert('登录状态丢失，测试问题中，请忽略此条提示。');
                        if (returnUrl) {
                            sessionStorage.setItem('loginReturnUrl', returnUrl);
                            window.parent.location.href = url;
                        }
                        else {
                            window.location.href = url;
                        }
                    }
                }
                else {
                    //只有生产环境才需要下面的代码
                    localStorage.removeItem('token');
                    localStorage.removeItem("refresh_token");
                    localStorage.setItem('loginBeforeUrl', window.location.href);
                    if (sessionStorage.getItem('eamconfig') === '1')
                        return false;
                    localStorage.setItem('loginBeforeUrl', window.location.href);
                    axios.post(`${env.oauthHost}/public/nsc/webeam/config?code=authorize&url=${window.location.origin}`).then((res) => {
                        if (res.errcode === 0) {
                            sessionStorage.setItem('eamconfig', "1");
                            let url = `${res.data.url}${res.data.api}?client_id=${res.data.clientId}&state=${res.data.state}&scope=${res.data.scope}&redirect_uri=${res.data.redirectUri}&response_type=${res.data.responseType}&nonce=${res.data.nonce}`;
                            window.location.href = url;
                        }
                        else {
                            if (error.response.config &&
                                error.response.config.url.indexOf("public/system/config") === -1) {
                                const corpId = localStorage.getItem("corpId") || "";
                                let returnUrl = '';
                                if (window.top !== window.self) {
                                    console.log(window.parent.location.href);
                                    returnUrl = window.parent.location.href;
                                }
                                let url = `${env.portalHost}/login`;
                                if (corpId) {
                                    url = `${url}?corpId=${corpId}`;
                                }
                                if (returnUrl) {
                                    sessionStorage.setItem('loginReturnUrl', returnUrl);
                                    window.parent.location.href = url;
                                }
                                else {
                                    window.location.href = url;
                                }
                            }
                        }
                    });
                }
                break;
            default:
                // note: 20191030 增加判断阻断，避免重复跳转死循环。
                const localUrl = window.location.href;
                if (localUrl.indexOf("/error") < 0 && localUrl.indexOf("/login") < 0) {
                    // window.location.href = '/error';
                }
                break;
        }
    }
    return Promise.reject(error);
});
export default axios;
